export type { ApolloClientAiAppsConfig } from "./types.js";
export { defineConfig } from "./defineConfig.js";
